"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _myaccountSlice = require("../../redux/myaccountSlice");
var _MyAccountMenu = require("./MyAccountMenu.const");
var _MyAccountMenuStyled = require("./MyAccountMenuStyled");
var _jsxRuntime = require("react/jsx-runtime");
const MyAccountMenu = () => {
  const {
    activeTab
  } = (0, _reactRedux.useSelector)(state => state.myaccount);
  const dispatch = (0, _reactRedux.useDispatch)();
  const onMenuItemClick = id => {
    dispatch((0, _myaccountSlice.setActiveTab)(id));
  };
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountMenuStyled.WrapStyled, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountMenuStyled.ItemsStyled, {
      children: _MyAccountMenu.MenuItems.map(_ref => {
        let {
          icon,
          label,
          visibleOnDesktop,
          id,
          translationKey
        } = _ref;
        const IconComponent = icon || _react.default.Fragment;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountMenuStyled.ItemWrapStyled, {
          visibleOnDesktop: visibleOnDesktop,
          onClick: () => onMenuItemClick(id),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MyAccountMenuStyled.ItemStyled, {
            isActive: activeTab === id,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountMenuStyled.ItemIconWrapStyled, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {})
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountMenuStyled.ItemLabelStyled, {
              children: t(translationKey, label)
            })]
          })
        }, label);
      })
    })
  });
};
var _default = exports.default = MyAccountMenu;